import React, { useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { Search, Filter, Eye, Truck, Package, Clock, CheckCircle, AlertTriangle, MapPin, Phone, Mail, TrendingUp, Activity } from 'lucide-react';
export function OrderTracking() {
  const [viewMode, setViewMode] = useState<'list' | 'map'>('list');
  const orders = [{
    id: 'PO-2023-001',
    cooperative: 'Koperasi Maju Jaya',
    location: 'Bogor, Jawa Barat',
    date: '10 Okt 2023',
    items: 32,
    total: 4500000,
    status: 'in_transit',
    statusLabel: 'Dalam Pengiriman',
    courier: 'JNE Trucking',
    courierPhone: '+62 812-9999-8888',
    trackingNumber: 'JNE88291002',
    currentLocation: 'Gudang Transit Bogor',
    eta: 'Besok, 14:00 WIB',
    progress: 75,
    lastUpdate: '2 jam lalu'
  }, {
    id: 'PO-2023-002',
    cooperative: 'Koperasi Sejahtera',
    location: 'Bandung, Jawa Barat',
    date: '10 Okt 2023',
    items: 18,
    total: 2100000,
    status: 'in_transit',
    statusLabel: 'Dalam Pengiriman',
    courier: 'SiCepat Cargo',
    courierPhone: '+62 813-8888-7777',
    trackingNumber: 'SC12345678',
    currentLocation: 'Dalam Perjalanan ke Bandung',
    eta: 'Hari ini, 16:00 WIB',
    progress: 60,
    lastUpdate: '30 menit lalu'
  }, {
    id: 'PO-2023-003',
    cooperative: 'Tani Makmur',
    location: 'Sukabumi, Jawa Barat',
    date: '9 Okt 2023',
    items: 45,
    total: 6800000,
    status: 'processing',
    statusLabel: 'Dikemas',
    courier: 'JNE Trucking',
    courierPhone: '-',
    trackingNumber: 'JNE88291004',
    currentLocation: 'Gudang PTX',
    eta: 'Besok, 10:00 WIB',
    progress: 40,
    lastUpdate: '1 jam lalu'
  }, {
    id: 'PO-2023-004',
    cooperative: 'Desa Mandiri',
    location: 'Cianjur, Jawa Barat',
    date: '8 Okt 2023',
    items: 28,
    total: 3200000,
    status: 'delayed',
    statusLabel: 'Terlambat',
    courier: 'J&T Cargo',
    courierPhone: '+62 815-7777-6666',
    trackingNumber: 'JT98765432',
    currentLocation: 'Terhenti di Sorting Center',
    eta: 'Terlambat 2 hari',
    progress: 50,
    lastUpdate: '5 jam lalu'
  }];
  const stats = [{
    label: 'Total Aktif',
    value: '24',
    icon: Package,
    color: 'blue',
    trend: '+3'
  }, {
    label: 'Dalam Pengiriman',
    value: '18',
    icon: Truck,
    color: 'violet',
    trend: '+5'
  }, {
    label: 'Dikemas',
    value: '6',
    icon: Clock,
    color: 'amber',
    trend: '-2'
  }, {
    label: 'Terlambat',
    value: '2',
    icon: AlertTriangle,
    color: 'red',
    trend: '+1'
  }];
  return <div className="space-y-6" data-id="element-861">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-862">
        <div data-id="element-863">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-864">
            Monitor Pengiriman Real-time
          </h2>
          <p className="text-sm text-slate-500 mt-1" data-id="element-865">
            Pantau status pengiriman ke semua koperasi
          </p>
        </div>
        <div className="flex items-center gap-2 px-4 py-2 bg-green-50 border border-green-200 rounded-lg" data-id="element-866">
          <Activity className="w-4 h-4 text-green-600 animate-pulse" data-id="element-867" />
          <span className="text-sm font-bold text-green-700" data-id="element-868">
            Live Tracking Aktif
          </span>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-4 gap-4" data-id="element-869">
        {stats.map((stat, i) => {
        const Icon = stat.icon;
        return <Card key={i} className={`p-5 bg-gradient-to-br from-${stat.color}-50 to-${stat.color}-100 border-${stat.color}-200`} data-id="element-870">
              <div className="flex items-center justify-between mb-3" data-id="element-871">
                <div className={`w-12 h-12 bg-${stat.color}-600 rounded-xl flex items-center justify-center shadow-lg`} data-id="element-872">
                  <Icon className="w-6 h-6 text-white" data-id="element-873" />
                </div>
                <Badge className={`bg-${stat.color}-200 text-${stat.color}-800 border-0`} data-id="element-874">
                  <TrendingUp className="w-3 h-3 mr-1" data-id="element-875" />
                  {stat.trend}
                </Badge>
              </div>
              <p className={`text-sm text-${stat.color}-700 mb-1`} data-id="element-876">
                {stat.label}
              </p>
              <p className={`text-4xl font-bold text-${stat.color}-900`} data-id="element-877">
                {stat.value}
              </p>
            </Card>;
      })}
      </div>

      {/* Filters */}
      <div className="flex gap-3" data-id="element-878">
        <div className="relative flex-1" data-id="element-879">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" data-id="element-880" />
          <input type="text" placeholder="Cari PO, koperasi, atau nomor resi..." className="w-full pl-10 pr-4 py-3 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white" data-id="element-881" />
        </div>
        <select className="px-4 py-3 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white" data-id="element-882">
          <option data-id="element-883">Semua Status</option>
          <option data-id="element-884">Dalam Pengiriman</option>
          <option data-id="element-885">Dikemas</option>
          <option data-id="element-886">Terlambat</option>
        </select>
        <button className="px-4 py-3 bg-white border border-slate-200 rounded-xl hover:bg-slate-50 transition-colors flex items-center gap-2" data-id="element-887">
          <Filter className="w-5 h-5 text-slate-600" data-id="element-888" />
          <span className="font-medium text-slate-700" data-id="element-889">Filter</span>
        </button>
      </div>

      {/* Orders List */}
      <div className="space-y-4" data-id="element-890">
        {orders.map(order => <Card key={order.id} className={`p-6 ${order.status === 'delayed' ? 'border-red-200 bg-red-50/30' : ''}`} data-id="element-891">
            <div className="flex items-start gap-6" data-id="element-892">
              {/* Status Indicator */}
              <div className="flex-shrink-0" data-id="element-893">
                <div className={`w-16 h-16 rounded-xl flex items-center justify-center ${order.status === 'in_transit' ? 'bg-gradient-to-br from-blue-500 to-blue-600' : order.status === 'processing' ? 'bg-gradient-to-br from-amber-500 to-amber-600' : 'bg-gradient-to-br from-red-500 to-red-600'} shadow-lg`} data-id="element-894">
                  {order.status === 'in_transit' ? <Truck className="w-8 h-8 text-white" data-id="element-895" /> : order.status === 'processing' ? <Package className="w-8 h-8 text-white" data-id="element-896" /> : <AlertTriangle className="w-8 h-8 text-white" data-id="element-897" />}
                </div>
              </div>

              {/* Order Info */}
              <div className="flex-1 min-w-0" data-id="element-898">
                <div className="flex items-start justify-between mb-3" data-id="element-899">
                  <div data-id="element-900">
                    <div className="flex items-center gap-3 mb-2" data-id="element-901">
                      <h3 className="text-xl font-bold text-slate-900" data-id="element-902">
                        {order.id}
                      </h3>
                      <Badge variant={order.status === 'in_transit' ? 'warning' : order.status === 'processing' ? 'warning' : 'neutral'} className={order.status === 'delayed' ? 'bg-red-100 text-red-700' : ''} data-id="element-903">
                        {order.statusLabel}
                      </Badge>
                    </div>
                    <div className="flex items-center gap-4 text-sm text-slate-600" data-id="element-904">
                      <span className="font-bold text-slate-900" data-id="element-905">
                        {order.cooperative}
                      </span>
                      <span className="text-slate-400" data-id="element-906">•</span>
                      <div className="flex items-center gap-1" data-id="element-907">
                        <MapPin className="w-4 h-4" data-id="element-908" />
                        <span data-id="element-909">{order.location}</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-right" data-id="element-910">
                    <p className="text-sm text-slate-500 mb-1" data-id="element-911">Total Nilai</p>
                    <p className="text-xl font-bold text-blue-600" data-id="element-912">
                      Rp {(order.total / 1000000).toFixed(1)}Jt
                    </p>
                  </div>
                </div>

                {/* Progress */}
                <div className="mb-4" data-id="element-913">
                  <div className="flex justify-between items-center mb-2" data-id="element-914">
                    <div className="flex items-center gap-2" data-id="element-915">
                      <MapPin className="w-4 h-4 text-blue-600" data-id="element-916" />
                      <span className="text-sm font-medium text-slate-900" data-id="element-917">
                        {order.currentLocation}
                      </span>
                    </div>
                    <span className="text-xs text-slate-500" data-id="element-918">
                      Update: {order.lastUpdate}
                    </span>
                  </div>
                  <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-919">
                    <div className={`h-full rounded-full transition-all duration-500 ${order.status === 'delayed' ? 'bg-gradient-to-r from-red-500 to-red-600' : order.status === 'in_transit' ? 'bg-gradient-to-r from-blue-500 to-blue-600' : 'bg-gradient-to-r from-amber-500 to-amber-600'}`} style={{
                  width: `${order.progress}%`
                }} data-id="element-920"></div>
                  </div>
                  <div className="flex justify-between items-center mt-1" data-id="element-921">
                    <span className="text-xs text-slate-600" data-id="element-922">
                      ETA: {order.eta}
                    </span>
                    <span className="text-xs font-bold text-slate-900" data-id="element-923">
                      {order.progress}%
                    </span>
                  </div>
                </div>

                {/* Details */}
                <div className="flex items-center justify-between pt-4 border-t border-slate-100" data-id="element-924">
                  <div className="flex items-center gap-6 text-sm" data-id="element-925">
                    <span className="text-slate-600" data-id="element-926">{order.items} Item</span>
                    <span className="text-slate-400" data-id="element-927">•</span>
                    <span className="text-slate-600" data-id="element-928">
                      Kurir: {order.courier}
                    </span>
                    <span className="text-slate-400" data-id="element-929">•</span>
                    <span className="text-slate-600 font-mono text-xs" data-id="element-930">
                      Resi: {order.trackingNumber}
                    </span>
                    {order.courierPhone !== '-' && <>
                        <span className="text-slate-400" data-id="element-931">•</span>
                        <div className="flex items-center gap-1" data-id="element-932">
                          <Phone className="w-4 h-4 text-green-600" data-id="element-933" />
                          <span className="text-green-600 font-medium" data-id="element-934">
                            {order.courierPhone}
                          </span>
                        </div>
                      </>}
                  </div>

                  <div className="flex gap-2" data-id="element-935">
                    {order.status === 'delayed' && <Button variant="outline" size="sm" className="text-red-600 border-red-200 hover:bg-red-50" icon={<Phone className="w-4 h-4" data-id="element-937" />} data-id="element-936">
                        Hubungi Kurir
                      </Button>}
                    <Button variant="primary" size="sm" icon={<Eye className="w-4 h-4" data-id="element-939" />} data-id="element-938">
                      Detail Tracking
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Card>)}
      </div>
    </div>;
}